import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.find";
import "core-js/modules/es.object.freeze";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib"; // TODO 传入参数数据校验（响应式）

import { Vue, Component, Prop, Emit } from 'vue-property-decorator';

var ClientListTable = /*#__PURE__*/function (_Vue) {
  _inherits(ClientListTable, _Vue);

  var _super = _createSuper(ClientListTable);

  function ClientListTable() {
    var _this;

    _classCallCheck(this, ClientListTable);

    _this = _super.apply(this, arguments);
    _this.dic = _this.$store.getters.dic;
    _this.expandBaseDic = Object.freeze([{
      label: '姓名',
      key: 'partyName'
    }, {
      label: '诉讼地位',
      key: 'litigationStatus'
    }, {
      label: '当事人类别',
      key: 'partyType'
    }, {
      label: '证件号',
      key: 'idCard'
    }, {
      label: '联系方式',
      key: 'phoneNo'
    }, {
      label: '性别',
      key: 'sex'
    }, {
      label: '年龄',
      key: 'age'
    }, {
      label: '居住地址',
      key: 'address'
    }, {
      label: '民族',
      key: 'nation'
    }, {
      label: '文化程度',
      key: 'education'
    }]);
    _this.expandUnitDic = Object.freeze([{
      label: '单位名称',
      key: 'corpName'
    }, {
      label: '单位地址',
      key: 'corpAddress'
    }, {
      label: '单位电话',
      key: 'corpPhone'
    }]);
    _this.partyTypeMap = Object.freeze({
      person: '自然人 ',
      corporation: '法人',
      org: '非法人机构'
    });
    _this.contentMap = Object.freeze({
      partyType: function partyType(item) {
        return _this.partyTypeMap[item.partyType];
      },
      litigationStatus: function litigationStatus(item) {
        return item.litigationStatusOneName || '';
      },
      idCard: function idCard(item) {
        var idCardType = _this.dic.certificateTypeList.find(function (i) {
          return item.certificateType && i.value === item.certificateType;
        });

        return "".concat(idCardType ? idCardType.label : '', " ").concat(item.idCardNo);
      },
      sex: function sex(item) {
        var sex = _this.dic.sexList.find(function (i) {
          return item.sex && i.value === item.sex;
        });

        return sex ? sex.label : '';
      },
      education: function education(item) {
        var education = _this.dic.educationList.find(function (i) {
          return item.education && i.value === item.education;
        });

        return education ? education.label : '';
      }
    });
    return _this;
  }

  _createClass(ClientListTable, [{
    key: "expandContent",
    value: function expandContent(row, key) {
      return this.contentMap[key] ? this.contentMap[key](row) || '--' : row[key] || '--';
    }
  }, {
    key: "handleEdit",
    value: function handleEdit(item) {
      return item;
    }
  }, {
    key: "handleDelete",
    value: function handleDelete(item) {
      return item;
    }
  }, {
    key: "onComfireDelete",
    value: function onComfireDelete(item) {
      var _this2 = this;

      this.$confirm("\u6B64\u64CD\u4F5C\u5C06\u5220\u9664".concat(item.row.partyName, ", \u662F\u5426\u7EE7\u7EED?"), {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'question'
      }).then(function () {
        _this2.handleDelete(item);
      }).catch(function () {});
    }
  }]);

  return ClientListTable;
}(Vue);

__decorate([Prop({
  required: true
})], ClientListTable.prototype, "data", void 0);

__decorate([Prop({
  type: Boolean,
  default: function _default() {
    return false;
  }
})], ClientListTable.prototype, "editable", void 0);

__decorate([Emit('onEdit')], ClientListTable.prototype, "handleEdit", null);

__decorate([Emit('onDelete')], ClientListTable.prototype, "handleDelete", null);

ClientListTable = __decorate([Component({
  components: {}
})], ClientListTable);
export default ClientListTable;